import * as React from "react";
const SvgFiRrFaceRaisedEyebrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-raised-eyebrow_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10m5-6a1 1 0 0 1-1 1H8a1 1 0 1 1 0-2h8a1 1 0 0 1 1 1m0-5.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 17 10.5m-7 0a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 10 10.5M7 8a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2zm11.205-1.679a1 1 0 0 1-1.647 1.135C16.533 7.425 16.191 7 15.5 7c-.972 0-1.569 1.365-1.575 1.38a1.006 1.006 0 0 1-1.303.543 1 1 0 0 1-.549-1.297C12.467 6.65 13.632 5 15.5 5c1.744 0 2.612 1.187 2.705 1.321"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-raised-eyebrow_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceRaisedEyebrow;
